const img = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70`;

export const HERO_IMG = "/img/hero.jpg";

export const PRODUCTS = [
  { num: "01", slug: "acp-sheets", name: "ACP Sheets", full: "Aluminium Composite Panels", cat: "INTERIOR × EXTERIOR", img: img("photo-1493397212122-2b85dda8106b") },
  { num: "02", slug: "hpl-sheets", name: "HPL Sheets", full: "High Pressure Laminates", cat: "INTERIOR × EXTERIOR", img: img("photo-1487958449943-2429e8be8625") },
  { num: "03", slug: "acrylic-sheets", name: "Acrylic Sheets", full: "Acrylic Surface Sheets", cat: "INTERIOR", img: img("photo-1550684376-efcbd6e3f031") },
  { num: "04", slug: "glasses", name: "Glasses", full: "Architectural Glass", cat: "INTERIOR × EXTERIOR", img: img("photo-1545324418-cc1a3fa10c00") },
  { num: "05", slug: "pvc-soffit-panels", name: "PVC-Soffit Panels", full: "PVC Soffit Systems", cat: "EXTERIOR", img: img("photo-1600585154526-990dced4db0d") },
  { num: "06", slug: "wpc-fluted-panels", name: "WPC-Fluted Panels", full: "Wood Polymer Composite", cat: "INTERIOR", img: img("photo-1600566753190-17f0baa2a6c3") },
  { num: "07", slug: "3d-wall-panels", name: "3D Wall Panels", full: "Dimensional Wall Surfaces", cat: "INTERIOR", img: img("photo-1595428774223-ef52624120d2") },
  { num: "08", slug: "uv-marble-sheets", name: "UV Marble Sheets", full: "UV Coated Marble Sheets", cat: "INTERIOR", img: img("photo-1567095761054-7a02e69e5c43") },
  { num: "09", slug: "false-ceiling", name: "False Ceiling", full: "Suspended Ceiling Systems", cat: "INTERIOR", img: img("photo-1600607687939-ce8a6c25118c") },
  { num: "10", slug: "aluminium-profiles", name: "Aluminium Profiles", full: "Architectural Aluminium", cat: "EXTERIOR", img: img("photo-1431576901776-e539bd916ba2") },
  { num: "11", slug: "cement-fiber-boards", name: "Cement Fiber Boards", full: "Fibre Cement Boards", cat: "EXTERIOR", img: img("photo-1460574283810-2aab119d8511") },
  { num: "12", slug: "ms-pipes-angles", name: "MS Pipes – Angles", full: "Mild Steel Sections", cat: "EXTERIOR", img: img("photo-1600047509807-ba8f99d2cdde") },
];

export const MARQUEE_ROWS = [
  [PRODUCTS[0], PRODUCTS[1], PRODUCTS[2]],
  [PRODUCTS[3], PRODUCTS[4], PRODUCTS[5]],
  [PRODUCTS[6], PRODUCTS[7], PRODUCTS[8]],
  [PRODUCTS[9], PRODUCTS[10], PRODUCTS[11]],
];
export const MARQUEE_DURS = ["48s", "62s", "54s", "66s"];

export const SERVICES = [
  { num: "01", name: "Interior Design", desc: "Functional, aesthetic and innovative interior spaces that reflect your personality and purpose." },
  { num: "02", name: "Exterior Design", desc: "From modern facades to durable elevations — exterior solutions that combine strength, style and sustainability." },
  { num: "03", name: "Complete Solutions", desc: "From concept to completion, we bring your vision to life with carefully planned, professionally executed spaces." },
];

export const GALLERY = [
  { img: "/img/g1.jpg", title: "Lavender Ambient Interior", tag: "Interior" },
  { img: "/img/g2.jpg", title: "Ambient Living Space", tag: "Interior" },
  { img: "/img/g3.jpg", title: "Warm Contemporary Lounge", tag: "Interior" },
  { img: "/img/g4.jpg", title: "Modern Residential Interior", tag: "Interior" },
];

export const WHY = [
  { title: "Experienced Team", desc: "Skilled professionals with years of experience delivering quality interior and exterior solutions." },
  { title: "Quality Craftsmanship", desc: "Precision, durable materials and attention to detail in every project we undertake." },
  { title: "End-to-End Solutions", desc: "From initial concepts to final execution, we help bring your vision to life." },
  { title: "Personalized Designs", desc: "Every space is designed around your requirements, lifestyle, preferences and budget." },
  { title: "Transparent Process", desc: "Clear communication and careful planning keep you informed throughout the project." },
  { title: "Customer Satisfaction", desc: "We build lasting relationships by focusing on quality, reliability and client satisfaction." },
];

export const TESTIMONIALS = [
  { quote: "They did a very good interior work to my house. The work and output they created made my dream house look a lot more beautiful.", name: "Vinoth Kumar" },
  { quote: "Very good work. Best interior designs ever seen.", name: "Shree CR7" },
  { quote: "Good experience.", name: "Rekha Dhuruvan" },
  { quote: "Loved the service.", name: "Zack Yuko" },
];

export const JOURNAL = [
  { img: "/img/b1.jpg", tags: ["Interior Design", "Inspiration"], title: "5 Ways to Make Your Home Feel More Spacious" },
  { img: "/img/b2.jpg", tags: ["Exterior Design", "Ideas"], title: "Creating a Modern Exterior That Stands Out" },
  { img: "/img/b3.jpg", tags: ["Design Tips", "Home"], title: "Choosing the Right Design for Your Space" },
];

export const STATS = [
  { value: 25, suffix: "+", label: "Years of experience" },
  { value: 40, suffix: "+", label: "Projects completed" },
  { value: 3, suffix: "", label: "Generations of expertise" },
  { text: "CBE", label: "Based in Coimbatore" },
];

export const PHONE = "+91 99845 74187";
export const WHATSAPP = "+91 98430 74187";
export const telLink = `tel:${PHONE.replace(/\s/g, "")}`;
export const waLink = (msg = "Hi INT–EXT, I'd like to discuss a project.") =>
  `https://wa.me/919843074187?text=${encodeURIComponent(msg)}`;

// Privacy-conscious first-party event ping (no personal data, fire-and-forget)
export const track = (type) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: String(type).slice(0, 40) }),
    }).catch(() => {});
  } catch {}
};
